module.exports = __webpack_public_path__ + "static/media/flag-for-flag-india-svgrepo-com.c1e93bb2.svg";